import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    this.interval = undefined;

    const hideIt = ($it) => {
      $it.classList.remove('block');
      $it.classList.add('hidden');
    }, showIt = ($it) => {
      $it.classList.add('block');
      $it.classList.remove('hidden');
    }

    this.element.querySelectorAll('ul li[aria-label]').forEach(($el) => {
      $el.addEventListener('click', (ev) => {
        ev.preventDefault();
        document.querySelectorAll('.nav-group').forEach(($el) => hideIt($el));
        showIt(document.querySelector(`.nav-group.${$el.ariaLabel}`));
        this.openMenu();
      });
    });

    // Close the sidebar (mobile drawer or desktop expanded menu) when clicking outside of it.
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    document.addEventListener('click', this.handleOutsideClick);
  }

  openMenu() {
    let sidebar = document.querySelector('#logo-sidebar');
    !!sidebar && sidebar.setAttribute('aria-menu', 'opened');
  }

  handleOutsideClick(event) {
    let wrapper = document.querySelector('#wrapper-sidebar'),
      sidebar = document.querySelector('#logo-sidebar');

    if (!wrapper)
      return;

    // Ignore clicks inside the menu itself or on the mobile toggle button.
    if (wrapper.contains(event.target) || event.target.closest('[data-drawer-toggle="wrapper-sidebar"]'))
      return;

    // Mobile: aria-modal=true is set by Flowbite only while the drawer is open.
    if (wrapper.getAttribute('aria-modal') === 'true') {
      let drawer = window.FlowbiteInstances?.getInstance('Drawer', 'wrapper-sidebar');
      !!drawer && drawer.hide();
      return;
    }

    // Desktop: collapse the expanded menu unless it is pinned open.
    if (sidebar && sidebar.getAttribute('aria-menu') === 'opened' && sidebar.getAttribute('aria-pin') !== 'pin')
      sidebar.setAttribute('aria-menu', 'closed');
  }

  disconnect() {
    clearInterval(this.interval);
    document.removeEventListener('click', this.handleOutsideClick);
  }
}